"use client";
import Icon from "@/components/icons/Icons";
import CustomModal from "@/components/modal/CustomModal";
import Image from "next/image";
import React, { useState } from "react";

type VideoItems = {
  url: string;
  title?: string | null;
};

export default function YouTubeModal({ url, title }: VideoItems) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="relative group block mx-auto w-full max-w-96 xs:w-53.75 h-40 xs:h-30 rounded-md overflow-hidden shrink-0 border border-[#909090]"
      >
        <Image
          fill
          src={`https://img.youtube.com/vi/${url}/hqdefault.jpg`}
          alt={`YouTube video about ${title ?? "Mutual Fund"}`}
          className="object-cover object-center"
        />
        <div className="absolute inset-0 z-1 flex items-center justify-center bg-black/30 rounded-md pointer-events-none opacity-0 group-hover:opacity-100 transition">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-12 h-12 text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
        <Icon.ytBtnIcon className="w-12 h-12 absolute inset-0 z-0 m-auto" />
      </button>
      <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        isBlurOverlay
        showCloseButton={false}
        maxSize="max-w-[750px] aspect-video"
        className="rounded-t-xl sm:rounded-xl h-56 sm:h-full"
      >
        <iframe
          width="215"
          height="120"
          src={`https://www.youtube.com/embed/${url}?autoplay=1`}
          title={`YouTube video about ${title ?? "Mutual Fund"}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="block mx-auto w-full h-full object-contain rounded-t-md sm:rounded-md shrink-0"
        />
      </CustomModal>
    </>
  );
}
